import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomepageCtaSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-appbg px-6 py-14 lg:px-20 lg:py-20">
      <div className="mx-auto max-w-[1728px] rounded-2xl border border-primary-100 bg-card px-6 py-14 text-center shadow-sm sm:px-10 lg:px-16 lg:py-20">
        <h2 className="mx-auto max-w-[840px] text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-primary-800 sm:text-[46px] lg:text-[66px]">
          Ready to control your financial future?
        </h2>

        <p className="mx-auto mt-6 max-w-[820px] text-[14px] leading-[1.5] text-muted sm:text-[18px]">
          Join the new era of corporate travel and expense management. No setup fees. No hidden costs.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <button
            type="button"
            onClick={() => navigate('/contact?intent=get-started')}
            className="inline-flex h-12 min-w-[200px] items-center justify-center rounded-xl bg-primary-800 px-6 text-[24px] font-semibold text-white shadow-[0_14px_30px_-16px_rgba(0,58,82,0.55)] transition-colors duration-200 hover:bg-primary-700"
          >
            Get Started Now
          </button>

          <button
            type="button"
            onClick={() => {
              window.location.href = 'mailto:contact@flintpay.co';
            }}
            className="inline-flex h-12 min-w-[200px] items-center justify-center rounded-xl border border-line bg-card px-6 text-[24px] font-semibold text-ink transition-colors duration-200 hover:bg-primary-50"
          >
            Talk to Sales
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomepageCtaSection;
